import { Store, select } from '@ngrx/store';
import * as fromCard from '../state/selectors';
var CardOptionQuery = /** @class */ (function () {
    function CardOptionQuery(store) {
        this.store = store;
    }
    Object.defineProperty(CardOptionQuery.prototype, "values", {
        get: function () {
            return this.store.pipe(select(fromCard.getSearchOption));
        },
        enumerable: true,
        configurable: true
    });
    return CardOptionQuery;
}());
export { CardOptionQuery };
